import BackButton from "../components/BackButton";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function PasswordReset() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.passwordResetRequest(email.trim()); setSent(true); toast.success("Se l'email è registrata, riceverai un link."); }
    catch { toast.error("Errore"); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-dvh pxos-gradient-surface grid place-items-center px-4" data-testid="password-reset-page">
      <BackButton to="/login" testid="password-reset-back-btn" />
      <div className="w-full max-w-md pxos-card p-8">
        <h1 className="font-display text-2xl font-semibold text-center">Password dimenticata</h1>
        {sent ? (
          <p className="mt-4 text-sm text-center opacity-80">Se l'email è registrata, riceverai un link entro pochi minuti.<br /><Link to="/login" className="underline">Torna al login</Link></p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3" data-testid="password-reset-form">
            <label className="block"><span className="text-xs font-semibold uppercase tracking-widest">Email</span>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="pxos-input" data-testid="password-reset-email" /></label>
            <button disabled={busy} className="pxos-btn-primary w-full" data-testid="password-reset-submit">Invia link di reset</button>
            <p className="text-xs text-center opacity-70"><Link to="/login" className="underline">Torna al login</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}

export function PasswordResetConfirm() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [valid, setValid] = useState(null);
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.passwordResetValidate(token).then(() => setValid(true)).catch(() => setValid(false));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.passwordResetConfirm(token, pwd, pwd2);
      toast.success("Password aggiornata. Ora accedi.");
      nav("/login", { replace: true });
    } catch (err) { toast.error(err?.response?.data?.detail || "Errore"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-dvh pxos-gradient-surface grid place-items-center px-4" data-testid="password-reset-confirm-page">
      <BackButton to="/login" testid="password-reset-confirm-back-btn" />
      <div className="w-full max-w-md pxos-card p-8">
        {valid === null ? <div className="text-sm opacity-70">Verifica del link…</div> :
         valid === false ? <div className="text-sm text-red-800">Link non valido o scaduto. <Link to="/password-reset" className="underline">Richiedi un nuovo link</Link></div> :
         <form onSubmit={submit} className="space-y-3" data-testid="password-reset-confirm-form">
           <h1 className="font-display text-2xl font-semibold text-center">Nuova password</h1>
           <label className="block"><span className="text-xs font-semibold uppercase tracking-widest">Nuova password (min 12)</span>
             <input type="password" required minLength={12} value={pwd} onChange={(e) => setPwd(e.target.value)} className="pxos-input" data-testid="password-reset-new" /></label>
           <label className="block"><span className="text-xs font-semibold uppercase tracking-widest">Conferma</span>
             <input type="password" required minLength={12} value={pwd2} onChange={(e) => setPwd2(e.target.value)} className="pxos-input" data-testid="password-reset-new2" /></label>
           <button disabled={busy} className="pxos-btn-primary w-full" data-testid="password-reset-confirm-submit">Aggiorna</button>
         </form>}
      </div>
    </div>
  );
}
